export default class AtendimentoDeTerceiros {
    constructor(obj) {
      obj = obj || {};
      this.idUsuarioAbertura = obj.idUsuarioAbertura;
      this.loginUsuarioAbertura = obj.loginUsuarioAbertura;
      this.idUsuarioEncerramento = obj.idUsuarioEncerramento;
      this.loginUsuarioEncerramento = obj.loginUsuarioEncerramento;
      this.codigoChamada = obj.codigoChamada;
    }
  }